<template>
  <div class="bottom-nav">
    <div
      v-for="item in navItems"
      :key="item.name"
      class="nav-item"
      :class="{ active: isActive(item) }"
      @click="navigate(item.route)"
    >
      <div class="nav-icon">{{ item.icon }}</div>
      <div class="nav-label">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  data() {
    return {
      navItems: [
        { name: 'home', label: '首页', icon: '🏠', route: '/', routeName: 'Index' },
        { name: 'products', label: '产品', icon: '🎫', route: '/products', routeName: 'ProductList' },
        { name: 'orders', label: '订单', icon: '📋', route: '/orders', routeName: 'OrderList' },
        { name: 'profile', label: '我的', icon: '👤', route: '/profile', routeName: 'Profile' }
      ]
    }
  },
  methods: {
    isActive(item) {
      if (item.routeName === 'Index') {
        // /home/:merchantId 是首页在合作方免密登录场景下的独立路由，视觉上仍属于"首页"
        return this.$route.name === 'Index' || this.$route.name === 'IndexWithMerchant'
      }
      return this.$route.name === item.routeName
    },
    navigate(route) {
      if (this.$route.path !== route) {
        this.$router.push(route)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
  display: flex;
  z-index: 50;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.06);
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  transition: color 0.2s;
  color: #9ca3af;

  &.active {
    color: #ff720d;
  }

  &:active {
    opacity: 0.7;
  }
}

.nav-icon {
  font-size: 20px;
  line-height: 1;
}

.nav-label {
  font-size: 11px;
  font-weight: 500;
}
</style>
